export default __webpack_public_path__ + "static/small-business-accomplishment-2a-38e0986a2b81b49704df07742708f8cc.webp";